import { Page, pageMapper } from '@wix/funnel-builder-lizard'
import { tryCatchSync } from '@wix/funnel-utils'
import { useEffect, useMemo, useState } from 'react'

export const useForcePage = () => {
  const [hash, setHash] = useState<string>(window.location.hash)

  const forcePage = useMemo<Page | undefined>(() => {
    const [, forcePage] = tryCatchSync(() => parsePageFromHash(hash))
    return forcePage
  }, [hash])

  useEffect(() => {
    const updateHash = () => {
      setHash(window.location.hash)
    }

    window.addEventListener('hashchange', updateHash)
    return () => {
      window.removeEventListener('hashchange', updateHash)
    }
  }, [])

  return forcePage
}

const parsePageFromHash = (hash: string): Page | undefined => {
  const hashParams = new URLSearchParams(hash.slice(1))
  const forcePageContentParam = hashParams.get('forcePageContent')

  if (!forcePageContentParam) {
    return
  }

  const apiPage = JSON.parse(decodeURIComponent(forcePageContentParam))
  return pageMapper.toDomain(apiPage)
}
